import { useEffect, useRef, useState } from 'react'
import CreateButton from '../../../../Partials/Layouts/CRUDs/CRUDHeader/CreateButton/CreateButton';
import CRUDTable from '../../../../Partials/Layouts/CRUDs/CRUDTable/CRUDTable';
import CRUDTableHeader from '../../../../Partials/Layouts/CRUDs/CRUDTable/CRUDTableHeader/CRUDTableHeader';
import CRUDth from '../../../../Partials/Layouts/CRUDs/CRUDTable/CRUDTableHeader/CRUDth/CRUDth';
import ViewButton from '../../../../Partials/Layouts/CRUDs/CRUDButtons/ViewButton/ViewButton';
import EditButton from '../../../../Partials/Layouts/CRUDs/CRUDButtons/EditButton/EditButton';
import DeleteButton from '../../../../Partials/Layouts/CRUDs/CRUDButtons/DeleteButton/DeleteButton';
import ShortTextCell from '../../../../Partials/Layouts/CRUDs/CRUDTable/CRUDTableCells/ShortTextCell/ShortTextCell';
import CRUDTableRow from '../../../../Partials/Layouts/CRUDs/CRUDTable/CRUDTableRow/CRUDTableRow';
import Modal from '../../../../Partials/Elements/Modal/Modal';
import CreateDistrict from './CreateDistrict';
import ViewDistrict from './ViewDistrict';
import DeleteItem from '../../../../Partials/Layouts/DeleteItem/DeleteItem';
import UpdateDistrict from './UpdateDistrict';
import { DISTRICT_API } from '../../../../../Utilities/APIs/APIs';
import useAxiosInstance from '../../../../../Utilities/Hooks/useAxiosInstance';
import { useNavigate, useParams } from 'react-router-dom';
import CRUDButton from '../../../../Partials/Layouts/CRUDs/CRUDButtons/CRUDButton';
import { RiImage2Line } from 'react-icons/ri';

function Districts() {

  const axiosInstance = useAxiosInstance()

  const [districts, setDistricts] = useState(null)
  const screenHeaerRef = useRef()
  const [screenHeaderHeight, setScreenHeaderHeight] = useState(0);

  useEffect(() => {
    let screenHeaderHeight = screenHeaerRef.current.clientHeight;
    setScreenHeaderHeight(screenHeaderHeight)
  }, [screenHeaerRef]);

  const [showCreateForm, setShowCreateForm] = useState(false);
  const [showViewSection, setShowViewSection] = useState(false);
  const [showUpdateForm, setShowUpdateForm] = useState(false);
  const [showDeleteSection, setShowDeleteSection] = useState(false)
  const [toggleFetch, setToggleFetch] = useState(false)

  const [targetID, setTargetID] = useState(null)
  const navigate = useNavigate()
  const {parentID} =useParams()

  useEffect(() => {

  async function fetchAndSetDistricts() {
      const { data } = await axiosInstance.get(DISTRICT_API + 'getDistrictsFromDivision/' + parentID )
      setDistricts(data)
    }
    fetchAndSetDistricts()

  }, [toggleFetch, parentID, axiosInstance])

  function triggerFetch() {
    setToggleFetch(prevState => !prevState)
  }
  return (
    <>
      <div className='screen_header' ref={screenHeaerRef}>
        <h1 className='screen_heading'>Districts ({districts?.length}  in total)</h1>
        <CreateButton
          screenTopicSingular={'District'}
          setShowCreateForm={setShowCreateForm}
        />
      </div>
      <CRUDTable screenHeaderHeight={screenHeaderHeight}>
        <CRUDTableHeader>
          <CRUDth th='District' />
          <CRUDth th='Actions' />
        </CRUDTableHeader>
        <tbody>
          {
            districts?.map(district =>
              <CRUDTableRow key={district._id}>
                <ShortTextCell text={district.name} />
                <td>
                  <div className="action_buttons_wrapper">
                    <div className="action_buttons">
                      <ViewButton
                        setShowViewSection={setShowViewSection}
                        targetID={district._id}
                        setTargetID={setTargetID}
                        tooltipName={"View"} 
                        tooltipContent={"View"}

                      />

                      <EditButton
                        setShowUpdateForm={setShowUpdateForm}
                        targetID={district._id}
                        setTargetID={setTargetID}
                        tooltipName={"Edit"} 
                        tooltipContent={"Edit"}
                      />

                      <DeleteButton
                        setShowDeleteSection={setShowDeleteSection}
                        targetID={district._id}
                        setTargetID={setTargetID}
                        tooltipName={"Delete"} 
                        tooltipContent={"Delete"}
                      />
                       <CRUDButton
                        handleClick={() => navigate('/main/areas/' + district._id)}
                        tooltipName={"Area"} 
                        tooltipContent={"Area"}
                      >
                        <RiImage2Line />
                      </CRUDButton>
                    </div>
                  </div>
                </td>
              </CRUDTableRow>

            )
          }
        </tbody>
      </CRUDTable>
      {
        showCreateForm &&
        <Modal
          extraClass={'small'}
          modalHeading={`Create District`}
          setShowModalContent={setShowCreateForm}
        >
          <CreateDistrict
            triggerFetch={triggerFetch}
            setShowCreateForm={setShowCreateForm}
            division={parentID}
          />
        </Modal>
      }
      {
        showUpdateForm &&
        <Modal
          extraClass={'small'}
          modalHeading={`Update District`}
          setShowModalContent={setShowUpdateForm}
        >
          <UpdateDistrict
            triggerFetch={triggerFetch}
            targetID={targetID}
            setShowUpdateForm={setShowUpdateForm}
          />
        </Modal>
      }
      {
        showViewSection &&
        <Modal
          extraClass={'small'}
          modalHeading={`View District`}
          setShowModalContent={setShowViewSection}
        >
          <ViewDistrict
            targetID={targetID}
          />
        </Modal>
      }
      {
        showDeleteSection &&
        <Modal
          extraClass={'small'}
          modalHeading={`Delete District`}
          setShowModalContent={setShowDeleteSection}
        >
          <DeleteItem
            api={DISTRICT_API}
            triggerFetch={triggerFetch}
            targetID={targetID}
            setShowDeleteItem={setShowDeleteSection}
          />
        </Modal>
      }
    </>
  )
}

export default Districts